/**
 * Copyright (c) Asseco Business Solutions S.A. All rights reserved.
 */
import restService from "assecobs-react-utils/restService";
import {PERMISSION_URL} from "../common/Urls";

export function initPermissionModule() {
    return restService.getJSON(PERMISSION_URL).then(result => {
        return result;
    });
}

